export const MANAGEMENT_CARD_TITLE_FONT_SIZE = "0.875rem";
export const MANAGEMENT_CARD_META_FONT_SIZE = "0.8125rem";
export const MANAGEMENT_CARD_HEADER_FONT_SIZE = "0.75rem";
